// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Invoice & Recover semantic theme tokens. Values follow Figma variable set 39-2. */
:root,
html[data-theme="light"],
[data-document-theme="print"] {
  color-scheme: light;
  --bg-primary: #f4f7f7;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8edec;
  --surface-primary: #ffffff;
  --surface-secondary: #f4f7f7;
  --surface-tertiary: #e8edec;
  --surface-elevated: #ffffff;
  --border-default: #cdd6d4;
  --border-strong: #8b9996;
  --border-subtle: #dce3e2;
  --text-primary: #142624;
  --text-secondary: #506360;
  --text-tertiary: #6b7b78;
  --text-disabled: #8a9896;
  --text-inverse: #ffffff;
  --text-link: #0f766e;
  --interactive-default: #0f766e;
  --interactive-hover: #0a655f;
  --interactive-pressed: #084f4b;
  --interactive-disabled: #cdd6d4;
  --interactive-soft: #f0f8f7;
  --interactive-soft-hover: #e4f2f0;
  --interactive-selected: #dcefec;
  --on-interactive-primary: #ffffff;
  --on-interactive-disabled: #8a9896;
  --focus-ring: #0f766e;
  --danger-default: #c23a2b;
  --danger-soft: #fef2f1;
  --danger-text: #a3301f;
  --success-default: #15703d;
  --success-soft: #edfbf2;
  --success-text: #115a33;
  --warning-default: #b7701a;
  --warning-soft: #fef8ec;
  --warning-text: #7d4412;
  --info-default: #1a73e8;
  --info-soft: #eff6ff;
  --info-text: #315b8f;
  --money-overdue: #c23a2b;
  --money-paid: #15703d;
  --money-pending: #b7701a;
  --money-draft: #506360;
  --chart-primary: #0f766e;
  --chart-secondary: #aebab8;
  --chart-danger: #e04434;
  --chart-grid: #dce3e2;
  --overlay-default: rgb(0 0 0 / 45%);
  --overlay-heavy: rgb(0 0 0 / 70%);
  --toast-bg: #ffffff;
  --toast-text: #142624;
}

html[data-theme="dark"] {
  color-scheme: dark;
  --bg-primary: #101113;
  --bg-secondary: #17191c;
  --bg-tertiary: #202328;
  --surface-primary: #191b1f;
  --surface-secondary: #22252a;
  --surface-tertiary: #2b2f35;
  --surface-elevated: #25282e;
  --border-default: #3a3f47;
  --border-strong: #69727e;
  --border-subtle: #2c3036;
  --text-primary: #f2f3f5;
  --text-secondary: #b3b8c2;
  --text-tertiary: #9299a5;
  --text-disabled: #616975;
  --text-inverse: #101113;
  --text-link: #83c7be;
  --interactive-default: #43a79c;
  --interactive-hover: #83c7be;
  --interactive-pressed: #b6ded8;
  --interactive-disabled: #30343b;
  --interactive-soft: #22252a;
  --interactive-soft-hover: #2b2f35;
  --interactive-selected: #083836;
  --on-interactive-primary: #101113;
  --on-interactive-disabled: #727b88;
  --focus-ring: #71c9be;
  --danger-default: #f08078;
  --danger-soft: #332022;
  --danger-text: #f3aaa4;
  --danger-border: #614047;
  --success-default: #61bc8c;
  --success-soft: #1b2d25;
  --success-text: #94d3af;
  --success-border: #3f6650;
  --warning-default: #ddb56b;
  --warning-soft: #342b1d;
  --warning-text: #e6c78c;
  --warning-border: #695638;
  --info-default: #7fa8db;
  --info-soft: #1e2b3c;
  --info-text: #aec9ec;
  --info-border: #415c82;
  --money-overdue: #f08078;
  --money-overdue-soft: #332022;
  --money-paid: #61bc8c;
  --money-paid-soft: #1b2d25;
  --money-pending: #ddb56b;
  --money-pending-soft: #342b1d;
  --money-draft: #b3b8c2;
  --money-draft-soft: #22252a;
  --chart-primary: #43a79c;
  --chart-secondary: #77817c;
  --chart-tertiary: #97a6bf;
  --chart-danger: #f08078;
  --chart-success: #61bc8c;
  --chart-grid: #343940;
  --overlay-default: rgb(0 0 0 / 60%);
  --overlay-heavy: rgb(0 0 0 / 80%);
  --toast-bg: #25282e;
  --toast-text: #f2f3f5;
}

html,
body {
  background-color: var(--bg-primary);
}

/* Crossfade the whole theme together instead of staggering individual colors. */
html.theme-transition {
  cursor: pointer;
}

html.theme-transition,
html.theme-transition *,
html.theme-transition *::before,
html.theme-transition *::after {
  transition: none !important;
}

html.theme-transition::view-transition-old(root),
html.theme-transition::view-transition-new(root) {
  animation-duration: var(--duration-normal, 200ms);
  animation-timing-function: ease-in-out;
}

html.theme-transition::view-transition {
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  html.theme-transition::view-transition-old(root),
  html.theme-transition::view-transition-new(root) {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme-tokens.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,gFAAgF;AAChF;EACE,eAAe;AACjB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;EAEE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Shared Invoice & Recover semantic theme tokens. Values follow Figma variable set 39-2. */\n:root,\nhtml[data-theme=\"light\"],\n[data-document-theme=\"print\"] {\n  color-scheme: light;\n  --bg-primary: #f4f7f7;\n  --bg-secondary: #ffffff;\n  --bg-tertiary: #e8edec;\n  --surface-primary: #ffffff;\n  --surface-secondary: #f4f7f7;\n  --surface-tertiary: #e8edec;\n  --surface-elevated: #ffffff;\n  --border-default: #cdd6d4;\n  --border-strong: #8b9996;\n  --border-subtle: #dce3e2;\n  --text-primary: #142624;\n  --text-secondary: #506360;\n  --text-tertiary: #6b7b78;\n  --text-disabled: #8a9896;\n  --text-inverse: #ffffff;\n  --text-link: #0f766e;\n  --interactive-default: #0f766e;\n  --interactive-hover: #0a655f;\n  --interactive-pressed: #084f4b;\n  --interactive-disabled: #cdd6d4;\n  --interactive-soft: #f0f8f7;\n  --interactive-soft-hover: #e4f2f0;\n  --interactive-selected: #dcefec;\n  --on-interactive-primary: #ffffff;\n  --on-interactive-disabled: #8a9896;\n  --focus-ring: #0f766e;\n  --danger-default: #c23a2b;\n  --danger-soft: #fef2f1;\n  --danger-text: #a3301f;\n  --success-default: #15703d;\n  --success-soft: #edfbf2;\n  --success-text: #115a33;\n  --warning-default: #b7701a;\n  --warning-soft: #fef8ec;\n  --warning-text: #7d4412;\n  --info-default: #1a73e8;\n  --info-soft: #eff6ff;\n  --info-text: #315b8f;\n  --money-overdue: #c23a2b;\n  --money-paid: #15703d;\n  --money-pending: #b7701a;\n  --money-draft: #506360;\n  --chart-primary: #0f766e;\n  --chart-secondary: #aebab8;\n  --chart-danger: #e04434;\n  --chart-grid: #dce3e2;\n  --overlay-default: rgb(0 0 0 / 45%);\n  --overlay-heavy: rgb(0 0 0 / 70%);\n  --toast-bg: #ffffff;\n  --toast-text: #142624;\n}\n\nhtml[data-theme=\"dark\"] {\n  color-scheme: dark;\n  --bg-primary: #101113;\n  --bg-secondary: #17191c;\n  --bg-tertiary: #202328;\n  --surface-primary: #191b1f;\n  --surface-secondary: #22252a;\n  --surface-tertiary: #2b2f35;\n  --surface-elevated: #25282e;\n  --border-default: #3a3f47;\n  --border-strong: #69727e;\n  --border-subtle: #2c3036;\n  --text-primary: #f2f3f5;\n  --text-secondary: #b3b8c2;\n  --text-tertiary: #9299a5;\n  --text-disabled: #616975;\n  --text-inverse: #101113;\n  --text-link: #83c7be;\n  --interactive-default: #43a79c;\n  --interactive-hover: #83c7be;\n  --interactive-pressed: #b6ded8;\n  --interactive-disabled: #30343b;\n  --interactive-soft: #22252a;\n  --interactive-soft-hover: #2b2f35;\n  --interactive-selected: #083836;\n  --on-interactive-primary: #101113;\n  --on-interactive-disabled: #727b88;\n  --focus-ring: #71c9be;\n  --danger-default: #f08078;\n  --danger-soft: #332022;\n  --danger-text: #f3aaa4;\n  --danger-border: #614047;\n  --success-default: #61bc8c;\n  --success-soft: #1b2d25;\n  --success-text: #94d3af;\n  --success-border: #3f6650;\n  --warning-default: #ddb56b;\n  --warning-soft: #342b1d;\n  --warning-text: #e6c78c;\n  --warning-border: #695638;\n  --info-default: #7fa8db;\n  --info-soft: #1e2b3c;\n  --info-text: #aec9ec;\n  --info-border: #415c82;\n  --money-overdue: #f08078;\n  --money-overdue-soft: #332022;\n  --money-paid: #61bc8c;\n  --money-paid-soft: #1b2d25;\n  --money-pending: #ddb56b;\n  --money-pending-soft: #342b1d;\n  --money-draft: #b3b8c2;\n  --money-draft-soft: #22252a;\n  --chart-primary: #43a79c;\n  --chart-secondary: #77817c;\n  --chart-tertiary: #97a6bf;\n  --chart-danger: #f08078;\n  --chart-success: #61bc8c;\n  --chart-grid: #343940;\n  --overlay-default: rgb(0 0 0 / 60%);\n  --overlay-heavy: rgb(0 0 0 / 80%);\n  --toast-bg: #25282e;\n  --toast-text: #f2f3f5;\n}\n\nhtml,\nbody {\n  background-color: var(--bg-primary);\n}\n\n/* Crossfade the whole theme together instead of staggering individual colors. */\nhtml.theme-transition {\n  cursor: pointer;\n}\n\nhtml.theme-transition,\nhtml.theme-transition *,\nhtml.theme-transition *::before,\nhtml.theme-transition *::after {\n  transition: none !important;\n}\n\nhtml.theme-transition::view-transition-old(root),\nhtml.theme-transition::view-transition-new(root) {\n  animation-duration: var(--duration-normal, 200ms);\n  animation-timing-function: ease-in-out;\n}\n\nhtml.theme-transition::view-transition {\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.theme-transition::view-transition-old(root),\n  html.theme-transition::view-transition-new(root) {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
